import axiosInstance from "../utils/axios";

export const institutionalVerificationService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get("/vocational-institution", {
      params,
    });
    return response.data;
  },
  fetchLegalityData: async (id) => {
    const response = await axiosInstance.get(
      `/vocational-institution/${id}/legality`
    );
    return response.data;
  },
  fetchFacilityData: async (id) => {
    const response = await axiosInstance.get(
      `/vocational-institution/${id}/facility`
    );
    return response.data;
  },
  fetchAllProgramData: async (id) => {
    const response = await axiosInstance.get(
      `/vocational-institution/${id}/program`
    );
    return response.data;
  },
  fetchDetailProgramData: async (id) => {
    const response = await axiosInstance.get(
      `/vocational-institution/program/${id}`
    );
    return response.data;
  },
  updateRegistrationStatusData: async (id, data) => {
    const response = await axiosInstance.put(
      `/vocational-institution/registration/${id}/status`,
      data
    );
    return response.data;
  },
  updateFacilityStatusData: async (id, data) => {
    const response = await axiosInstance.put(
      `/vocational-institution/facility/${id}/status`,
      data
    );
    return response.data;
  },
  updateProgramStatusData: async (id, data) => {
    const response = await axiosInstance.put(
      `/vocational-institution/program/${id}/status`,
      data
    );
    return response.data;
  },
  updateActiveStatus: async (id, data) => {
    const response = await axiosInstance.put(
      `/vocational-institution/${id}/status`,
      data
    );
    return response.data;
  },
  store: async (data) => {
    const response = await axiosInstance.post("/vocational-institution", data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await axiosInstance.put(
      `/vocational-institution/${id}`,
      data
    );
    return response.data;
  },
  delete: async (id) => {
    const response = await axiosInstance.delete(
      `/vocational-institution/${id}`
    );
    return response.data;
  },
  uploadCertificate: async (id, file, onUploadProgress) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axiosInstance.post(
      `/vocational-institution/${id}/certificate`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
      }
    );

    return response.data;
  },
  addFacilityMonitoring: async (id, { monitoredAt, purpose, document }) => {
    const formData = new FormData();
    formData.append("monitoredAt", monitoredAt);
    formData.append("purpose", purpose);
    formData.append("document", document);

    const response = await axiosInstance.post(
      `/vocational-institution/facility/${id}/monitoring`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
  },
  fetchCertificateData: async (id) => {
    const response = await axiosInstance.get(
      `/vocational-institution/${id}/certificate`
    );
    return response.data;
  },
  deleteCertificateData: async (id) => {
    const response = await axiosInstance.delete(
      `/vocational-institution/${id}/certificate`
    );
    return response.data;
  },
  exportExcel: async (params = {}) => {
    const response = await axiosInstance.get(
      "/vocational-institution/export-excel",
      {
        params,
        responseType: "blob",
      }
    );
    return response;
  },
};
